export const CHECKLIST_EXTERNAL_AREA_PAGE_VIEWED_ANALYTICS = 'CHECKLIST_EXTERNAL_AREA_PAGE_VIEWED_ANALYTICS';
export const EXTERNAL_AREA_FINISH_BUTTON_CLICKED_ANALYTICS = 'EXTERNAL_AREA_FINISH_BUTTON_CLICKED_ANALYTICS';
